import React from 'react';

import { styled } from '../theme';
import BodyText2 from './BodyText2';
import Dropdown from './Dropdown';
import FlexBox from './FlexBox';

const StyledFlexBox = styled(FlexBox)({
    alignItems: 'center',
});

const DropdownWrapper = styled('div')(({ theme }) => ({
    width: 70,
    zIndex: theme.zIndex.rowsPerPage,
}));

const Text = styled(BodyText2)({
    paddingRight: 10,
});

type Props = {
    label: string;
    value: number;
    options: number[];
    onChange: (ev) => void;
};

const RowsPerPageSelector: React.FC<Props> = ({ label, value, options, onChange, style }) => (
    <StyledFlexBox style={style}>
        <Text>{label}</Text>
        <DropdownWrapper>
            <Dropdown
                id="rows-per-page"
                options={options}
                color="primary"
                valueMode="single"
                value={value}
                onChange={onChange}
            />
        </DropdownWrapper>
    </StyledFlexBox>
);

export default RowsPerPageSelector;
